/* Live Free — the stockist map (StockistLocator.dc.html). No mapping library:
   the basemap is a pre-projected snippet, pins are re-placed here with the exact
   Mercator the basemap used, then zoom/pan (wheel, drag, pinch, +/−/reset) with
   pins and labels counter-scaled so they stay the same size on screen. At 3.2×
   a multi-shop market fans out into one pin per shop. Pin → market group; shop
   pin → that shop, opened. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lf-locator]');
  if (!root) return;
  var svg = root.querySelector('[data-lf-map]'), layer = root.querySelector('[data-lf-layer]');
  var S = parseFloat(root.dataset.projS), TX = parseFloat(root.dataset.projTx), TY = parseFloat(root.dataset.projTy);
  var W = 1000, H = 600, k = 1, tx = 0, ty = 0;
  function proj(lon, lat) { var x = S * lon * Math.PI / 180 + TX; var y = TY - S * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360)); return [x, y]; }
  function setAttrs(el, o) { Object.keys(o).forEach(function (a) { el.setAttribute(a, o[a]); }); }

  /* exact pin placement + cluster geometry */
  var pins = [], clusters = [];
  root.querySelectorAll('[data-lf-pin]').forEach(function (g) {
    var p = proj(parseFloat(g.dataset.lon), parseFloat(g.dataset.lat)), x = p[0], y = p[1];
    var dx = parseFloat(g.dataset.dx), dy = parseFloat(g.dataset.dy);
    var q = function (c) { return g.querySelector(c); };
    var pin = { g: g, x: x, y: y, dx: dx, dy: dy, count: parseInt(g.dataset.count, 10), line: q('.lf-loc__pinline'), halo: q('.lf-loc__pinhalo'), ring: q('.lf-loc__pinring'), dot: q('.lf-loc__pindot'), hit: q('.lf-loc__pinhit'), t1: q('.lf-loc__pinlabel'), t2: q('.lf-loc__pinsub') };
    pins.push(pin);
    var cl = root.querySelector('[data-lf-cluster="' + g.dataset.lfPin + '"]');
    if (cl) {
      var items = [];
      cl.querySelectorAll('.lf-loc__cpin').forEach(function (cg, i) {
        var a = (-126 + i * 44) * Math.PI / 180, ox = 132 * Math.cos(a), oy = 132 * Math.sin(a);
        items.push({ g: cg, ox: ox, oy: oy, ldx: ox >= 0 ? 14 : -14, anchor: ox >= 0 ? 'start' : 'end', line: cg.querySelector('.lf-loc__pinline'), ring: cg.querySelector('.lf-loc__pinring'), dot: cg.querySelector('.lf-loc__pindot'), text: cg.querySelector('.lf-loc__cname'), hit: cg.querySelector('.lf-loc__pinhit') });
      });
      clusters.push({ g: cl, x: x, y: y, items: items });
    }
  });

  function paint() {
    layer.setAttribute('transform', 'translate(' + tx + ' ' + ty + ') scale(' + k + ')');
    var expanded = k >= 3.2;
    pins.forEach(function (p) {
      var hide = expanded && p.count > 1;
      p.g.setAttribute('opacity', hide ? 0 : (expanded ? 0.42 : 1)); p.g.style.pointerEvents = hide ? 'none' : 'all';
      setAttrs(p.halo, { cx: p.x, cy: p.y, r: 26 / k }); setAttrs(p.ring, { cx: p.x, cy: p.y, r: 15 / k });
      setAttrs(p.dot, { cx: p.x, cy: p.y, r: 9 / k, 'stroke-width': 2.5 / k }); setAttrs(p.hit, { cx: p.x, cy: p.y, r: 30 / k });
      setAttrs(p.line, { x1: p.x, y1: p.y, x2: p.x + p.dx / k, y2: p.y + (p.dy - 4) / k, 'stroke-width': 1 / k });
      setAttrs(p.t1, { x: p.x + p.dx / k, y: p.y + p.dy / k, 'font-size': 19 / k });
      setAttrs(p.t2, { x: p.x + p.dx / k, y: p.y + (p.dy + 20) / k, 'font-size': 14 / k });
    });
    clusters.forEach(function (c) {
      c.g.setAttribute('opacity', expanded ? 1 : 0); c.g.style.pointerEvents = expanded ? 'all' : 'none';
      c.items.forEach(function (it) {
        it.g.setAttribute('tabindex', expanded ? '0' : '-1');
        var ox = it.ox / k, oy = it.oy / k;
        setAttrs(it.line, { x1: c.x, y1: c.y, x2: c.x + ox, y2: c.y + oy, 'stroke-width': 1 / k });
        setAttrs(it.ring, { cx: c.x + ox, cy: c.y + oy, r: 13 / k }); setAttrs(it.dot, { cx: c.x + ox, cy: c.y + oy, r: 7 / k, 'stroke-width': 2 / k });
        setAttrs(it.hit, { cx: c.x + ox, cy: c.y + oy, r: 22 / k });
        setAttrs(it.text, { x: c.x + ox + it.ldx / k, y: c.y + oy + 5 / k, 'font-size': 14 / k, 'text-anchor': it.anchor });
      });
    });
  }
  function clamp() {
    k = Math.max(1, Math.min(8, k));
    tx = Math.min(0, Math.max(W - W * k, tx)); ty = Math.min(0, Math.max(H - H * k, ty));
  }
  function zoomAt(f, cx, cy) { var nk = Math.max(1, Math.min(8, k * f)); f = nk / k; tx = cx - (cx - tx) * f; ty = cy - (cy - ty) * f; k = nk; clamp(); paint(); }
  function zoomTo(x, y, nk) { k = nk; tx = W / 2 - k * x; ty = H / 2 - k * y; clamp(); paint(); }
  function toSvg(e) { var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY; var m = svg.getScreenCTM(); if (!m) return [W / 2, H / 2]; var q = pt.matrixTransform(m.inverse()); return [q.x, q.y]; }

  /* controls */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lf-zoom]');
    if (b) { if (b.dataset.lfZoom === 'in') zoomAt(1.7, W / 2, H / 2); else if (b.dataset.lfZoom === 'out') zoomAt(1 / 1.7, W / 2, H / 2); else { k = 1; tx = ty = 0; paint(); } return; }
  });
  svg.addEventListener('wheel', function (e) { e.preventDefault(); var p = toSvg(e); zoomAt(e.deltaY < 0 ? 1.25 : 0.8, p[0], p[1]); }, { passive: false });
  var drag = null, moved = false, pinchD = 0;
  svg.addEventListener('pointerdown', function (e) { if (e.button && e.button !== 0) return; drag = { x: e.clientX, y: e.clientY, tx: tx, ty: ty }; moved = false; svg.setPointerCapture(e.pointerId); svg.classList.add('is-grabbing'); });
  svg.addEventListener('pointermove', function (e) { if (!drag) return; var m = svg.getScreenCTM(); var sx = m ? 1 / m.a : 1; var dx = (e.clientX - drag.x) * sx, dy = (e.clientY - drag.y) * sx; if (Math.abs(dx) + Math.abs(dy) > 3) moved = true; tx = drag.tx + dx; ty = drag.ty + dy; clamp(); paint(); });
  var end = function () { drag = null; svg.classList.remove('is-grabbing'); };
  svg.addEventListener('pointerup', end); svg.addEventListener('pointercancel', end);
  svg.addEventListener('touchstart', function (e) { if (e.touches.length === 2) pinchD = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); }, { passive: true });
  svg.addEventListener('touchmove', function (e) { if (e.touches.length === 2 && pinchD) { var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); zoomAt(d / pinchD, W / 2, H / 2); pinchD = d; } }, { passive: true });

  /* pins */
  function openShop(id) {
    var d = document.getElementById(id); if (!d) return;
    var m = d.closest('.lf-loc__market'); if (m) m.open = true;
    d.open = true; d.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function openMarket(id) { var d = document.getElementById(id); if (d) { d.open = true; d.scrollIntoView({ block: 'start', behavior: 'smooth' }); } }
  function activatePin(g) {
    var p = pins.filter(function (x) { return x.g === g; })[0]; if (!p) return;
    if (p.count === 1) { var first = document.querySelector('#' + g.dataset.lfPin + ' .lf-loc__shop'); openMarket(g.dataset.lfPin); if (first) first.open = true; }
    else { zoomTo(p.x, p.y, 4.2); openMarket(g.dataset.lfPin); }
  }
  svg.addEventListener('click', function (e) {
    if (moved) return;
    var cp = e.target.closest('[data-lf-shop]'); if (cp) { openShop(cp.dataset.lfShop); return; }
    var g = e.target.closest('[data-lf-pin]'); if (g) activatePin(g);
  });
  svg.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var cp = e.target.closest('[data-lf-shop]'); if (cp) { e.preventDefault(); openShop(cp.dataset.lfShop); return; }
    var g = e.target.closest('[data-lf-pin]'); if (g) { e.preventDefault(); activatePin(g); }
  });
  document.addEventListener('click', function (e) { var a = e.target.closest('[data-lf-open-market]'); if (a) { e.preventDefault(); openMarket(a.dataset.lfOpenMarket); } });
  if (location.hash.indexOf('#lf-market-') === 0) openMarket(location.hash.slice(1));
  paint();
})();